import { Crown, Truck } from "lucide-react";

/**
 * Inline badge shown in checkout summary when KAISO PRIME delivery benefit is active.
 * Also used in order confirmation to reinforce the value delivered.
 */
export default function KaisoPrimeCheckoutBadge({ savedAmount, compact = false }) {
  if (compact) {
    return (
      <div className="flex items-center gap-1.5 bg-purple-50 border border-purple-200 rounded-lg px-2 py-1 text-xs font-medium text-purple-700">
        <Crown className="w-3 h-3 text-yellow-500" />
        <Truck className="w-3 h-3" />
        <span>Benefício KAISO PRIME · Entrega grátis</span>
        {savedAmount > 0 && <span className="text-emerald-600 font-bold">-{savedAmount.toFixed(2).replace(".", ",")}€</span>}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 bg-gradient-to-r from-purple-50 to-yellow-50 border border-purple-200 rounded-xl p-3">
      <div className="w-8 h-8 bg-gradient-to-br from-purple-600 to-yellow-500 rounded-full flex items-center justify-center shrink-0">
        <Crown className="w-4 h-4 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-bold text-purple-700 uppercase tracking-wide">Benefício KAISO PRIME aplicado</p>
        <p className="text-sm text-gray-700 flex items-center gap-1">
          <Truck className="w-3.5 h-3.5 text-emerald-500" />
          Entrega grátis incluída no teu plano
        </p>
      </div>
      {savedAmount > 0 && (
        <div className="text-right shrink-0">
          <span className="text-lg font-black text-emerald-600">-{savedAmount.toFixed(2).replace(".", ",")}€</span>
        </div>
      )}
    </div>
  );
}
